// src/routes/DashboardRoutes.js
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom'; // Importa Navigate
import ProtectedRoute from './ProtectedRoute';
import { ROLES } from '../constants/roles'; // Importa ROLES

// Importa los arrays de rutas hijas
import administracionRoutes from './administracion/AdministracionRoutes';
import AdminRoutes from './admin/AdminRoutes';
import talentoHumanoRoutes from './talento-humano/TalentoHumanoRoutes';

// Carga diferida para el Dashboard principal
const Dashboard = lazy(() => import('../components/dashboard/Dashboard'));

// Define los roles generales para cada sección (para proteger las redirecciones)
const ROLES_TH_GENERAL = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.RECURSOS_HUMANOS];

const DashboardRoutes = [
  // 1. Ruta del Dashboard Principal
  {
    path: 'dashboard',
    element: (
      <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.RECURSOS_HUMANOS]}>
        <Dashboard />
      </ProtectedRoute>
    ),
  },

  // 2. Rutas de Subsecciones (importadas y combinadas)
  ...talentoHumanoRoutes,
  ...administracionRoutes,
  ...AdminRoutes,

  // 3. RUTAS DE REDIRECCIÓN
  {
    path: 'talento-humano',
    element: (
      <ProtectedRoute allowedRoles={ROLES_TH_GENERAL}>
        <Navigate to="/talento-humano/directorio" replace />
      </ProtectedRoute>
    ),
  },

  // Nota: La redirección raíz se maneja en AppRoutes.jsx
];

export default DashboardRoutes;
